import { render, staticRenderFns } from "./TimeDeposits.vue?vue&type=template&id=52a1ed46&scoped=true"
import script from "./TimeDeposits.vue?vue&type=script&lang=js"
export * from "./TimeDeposits.vue?vue&type=script&lang=js"
import style0 from "./TimeDeposits.vue?vue&type=style&index=0&id=52a1ed46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1ed46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLazy,VSpacer})
